import { useState, useEffect, useCallback } from 'react';
import { documentApi } from '../../../api/services';

interface UsePdfDocumentResult {
  blobUrl: string | null;
  isLoading: boolean;
  error: string | null;
  refetch: () => void;
}

export function usePdfDocument(documentId: string | null): UsePdfDocumentResult {
  const [blobUrl, setBlobUrl] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchDocument = useCallback(async () => {
    if (!documentId) {
      setBlobUrl(null);
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const blob = await documentApi.downloadDocument(documentId);
      const url = URL.createObjectURL(blob);
      setBlobUrl(url);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Fehler beim Laden des Dokuments');
      setBlobUrl(null);
    } finally {
      setIsLoading(false);
    }
  }, [documentId]);

  useEffect(() => {
    fetchDocument();

    return () => {
      if (blobUrl) {
        URL.revokeObjectURL(blobUrl);
      }
    };
  }, [documentId]);

  useEffect(() => {
    return () => {
      if (blobUrl) {
        URL.revokeObjectURL(blobUrl);
      }
    };
  }, [blobUrl]);

  return {
    blobUrl,
    isLoading,
    error,
    refetch: fetchDocument,
  };
}
